import React from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import { ReleasesProvider, useReleases } from "./ReleasesContext";
import { LabelsProvider, useLabels } from "./LabelsContext";

// Re-export the hooks for backward compatibility
export { useAuth } from "./AuthContext";
export { useLabels } from "./LabelsContext";
export { useReleases } from "./ReleasesContext";

// Combined hook for components that need multiple contexts
export const useAppContext = () => {
  const auth = useAuth();
  const labels = useLabels();
  const releases = useReleases();
  
  return {
    // Auth context
    userId: auth.userId,
    user: auth.user,
    isAuthenticated: auth.isAuthenticated,
    isAuthLoading: auth.isAuthLoading,
    signOut: auth.signOut,
    
    // Labels context
    paginatedLabels: labels.paginatedLabels,
    setLabelPage: labels.setLabelPage,
    searchTerm: labels.searchTerm,
    setSearchTerm: labels.setSearchTerm,
    isLoading: labels.isLoading,
    
    // Releases context
    toggleListen: releases.toggleListen,
    isSubmitting: releases.isSubmitting,
    loadingReleaseId: releases.loadingReleaseId,
    getSessionToggle: releases.getSessionToggle,
    
    // Combined error handling
    error: releases.error || labels.error
  };
};

// Combined provider that wraps all the individual providers
export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AuthProvider>
      <ReleasesProvider>
        <LabelsProvider>
          {children}
        </LabelsProvider>
      </ReleasesProvider>
    </AuthProvider>
  );
};

// For backward compatibility
export const AppContext = React.createContext<any>(null);
